import { AuthService } from 'src/app/services';
import { Component, OnInit } from '@angular/core';
import { SettingsPopUpService } from 'src/app/settings-pop-up.service';
import { MenuItemEnum } from 'src/app/enums/menuItemEnum';

@Component({
	selector: 'app-settings-pop-up-button',
	templateUrl: './settings-pop-up-button.component.html',
	styleUrls: ['./settings-pop-up-button.component.scss'],
    standalone: false
})
export class SettingsPopUpButtonComponent implements OnInit {

	public visible: boolean;

	constructor(
		public settingsPopUpService: SettingsPopUpService,
		public authService: AuthService,
	) { }

	ngOnInit(): void {
		this.authService.getPermissions(
			{
				showLoadingIndicator: false,
			}
		).subscribe(
			{
				next: (rolePermissions) => {
					for (let a = 0; a < rolePermissions.length; a++) {
						const rolePermission = rolePermissions[a];

						if (rolePermission.menuId === MenuItemEnum.GeneralSettings) {
							this.visible = true;

							break;
						}
					}
				}
			}
		);
	}
}
